<template>
  <div>
    <h4>Installation Issues</h4>
    <ResponsiveTable
        :items="installationIssues"
        :fields="installationIssuesFields"
        :searchable_fields="installationIssuesSearchableFields"
        sort-by="created"
        sort-direction="desc"
    >
        <template v-slot:cell(product_serial_num)="row">
          <b-icon icon="circle-fill" :variant="row.item.online ? 'success' : 'danger'"/>
          &nbsp
          <router-link :to="{ name: 'DevicePage', params: { serial: row.item.device_serial }}">{{ row.item.product_serial_num }}</router-link>
        </template>
      <template v-slot:cell(created)="row">
        {{ datetimeFormatter(row.item.created) }} (<timeago :datetime=row.item.created></timeago>)
      </template>
      <template #cell(data)="row">

        <span v-if="row.item.type === 'POLE_NOT_FOUND'">Device reporting GPS position
          <a :href="'https://www.openstreetmap.org/?mlat=' + row.item.data.device_position_y + '&mlon=' + row.item.data.device_position_x + '#map=14/' + row.item.data.device_position_y + '/' + row.item.data.device_position_x ">{{row.item.data.device_position_y}}, {{row.item.data.device_position_x}}</a>
            is <strong>{{row.item.data.pole_distance}} m</strong> from nearest pole.
        </span>

        <span v-if="row.item.type === 'POLE_IS_TAKEN'">Device reporting GPS position
          <a :href="'https://www.openstreetmap.org/?mlat=' + row.item.data.device_position_y + '&mlon=' + row.item.data.device_position_x + '#map=14/' + row.item.data.device_position_y + '/' + row.item.data.device_position_x ">{{row.item.data.device_position_y}}, {{row.item.data.device_position_x}}</a>
            near pole {{row.item.data.pole}} at location
          <a :href="'https://www.openstreetmap.org/?mlat=' + row.item.data.pole_position_y + '&mlon=' + row.item.data.pole_position_x + '#map=14/' + row.item.data.pole_position_y + '/' + row.item.data.pole_position_x ">{{row.item.data.pole_position_y}}, {{row.item.data.pole_position_x}}</a>
            distance <strong>{{row.item.data.distance}} m</strong> where other device <strong>{{row.item.data.other_device}}</strong> is already installed.

        </span>

        <span v-if="row.item.type === 'NO_GPS_POSITION'">
          Device hasn't reported GPS position.
        </span>

      </template>
    </ResponsiveTable>
  </div>
</template>

<script>
import datetimeFormatter from '@/core/datetimeFormatterHelper';
import { deviceService } from "@/_services";
import { mapActions } from 'vuex';
import ResponsiveTable from "@/components/ResponsiveTable/ResponsiveTable";

export default {
  name: 'InstallationIssues',
  components: {ResponsiveTable},
  data() {
    return {
      installationIssues: [],
      installationIssuesFields: [{
          key: 'product_serial_num',
          label: 'SERIAL',
          class: 'productSerialNum',
          sortable: true
        },
        {
          key: 'type',
          label: 'ISSUE',
          formatter: issue_wording_formatter,
          sortable: true
        },
        {
          key: 'data',
          label: 'DESCRIPTION',
          sortable: true
        },
        {
          key: 'created',
          label: 'SINCE',
          formatter: datetimeFormatter,
          sortable: true
        }
      ],
      installationIssuesSearchableFields: [
          "product_serial_num",
          "type",
          "data"
      ]

    };
  },
  methods: {
    ...mapActions('alert', ['error']),
    updateinstallationIssues() {
      deviceService.getInstallationIssues()
      .then(response => {
        this.installationIssues = response.data.issues
      })
      .catch(() => {
        this.error('Error getting Installation issues');
      });
    },
    datetimeFormatter(date) {
      return datetimeFormatter(date);
    }
  },
  mounted() {
    this.updateinstallationIssues();
  }
}

function issue_wording_formatter(issue) {
  const issue_wording = {
    POLE_NOT_FOUND: "Pole Not Found",
    POLE_IS_TAKEN: "Pole Is Taken",
    NO_GPS_POSITION: "No GPS Position"
  };
  return (issue in issue_wording) ? issue_wording[issue] : issue;
}

</script>

<style src="./InstallationIssues.scss" lang="scss" scoped/>
